import { useEffect } from 'react';

export const useBGBannerPadding = (
  headerHeight: number,
  isHomePage: boolean,
  selectors: string[] = ['.lotriver-bg-left', '.lotriver-bg-right']
) => {
  useEffect(() => {
    let frameId: number;

    const updatePadding = () => {
      selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (el instanceof HTMLElement) {
          const isFixed = getComputedStyle(el).position === 'fixed';
          el.style.paddingTop =
            !isHomePage && isFixed ? `${headerHeight}px` : '';
        }
      });
      frameId = requestAnimationFrame(updatePadding);
    };

    updatePadding();

    return () => cancelAnimationFrame(frameId);
  }, [isHomePage, headerHeight, selectors.join(',')]);
};
